import React from 'react';
import {deletePreform, getPreforms} from "../../../api/PreEForm";
import {confirmAlert} from "react-confirm-alert";
import DeleteDialog from "../../../components/DeleteDialog";

const textStyle = {
    width: "90%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    position: "relative",
    whiteSpace: "nowrap"
};


const PreEFormDeleteDialogBody = ({ formName, ssoReq, pefDate }) => (
    <div >
        <div><strong>Form:</strong>&nbsp;{formName}</div>
        <div style={textStyle}><strong>&nbsp;SSO/Req:</strong>{ssoReq}</div>
        <div><strong>Energization Date:</strong>&nbsp;{pefDate}</div>
    </div>
);


const ShowPreEFormDeleteDialog = (projectId, preFormId, peFormName, reqSOS, preEngDate, updateState) => {

    const reqSos = reqSOS ? reqSOS : "(empty)";
    const preEnergizationDate = preEngDate ? preEngDate.toString() : "(empty)";

    const options = {
        closeOnEscape: true,
        closeOnClickOutside: false,
        customUI: ({ onClose }) => <DeleteDialog
            onClose={ onClose }
            onAccept={ async () => {
                await deletePreform(preFormId);
                const forms = await getPreforms(projectId);
                updateState(forms);
                onClose();
            }}
            body={<PreEFormDeleteDialogBody formName={peFormName} ssoReq={reqSos} pefDate={preEnergizationDate} />}
        />
    };

    confirmAlert(options);
};


export default ShowPreEFormDeleteDialog;